<template>
  <div class="page-thirdparty-detail">
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li>
          <router-link :to="{ name: 'DashboardThirdParties' }"
            >Thirdparties</router-link
          >
        </li>
        <li class="is-active">
          <a aria-current="true">{{ thirdparty?.name }}</a>
        </li>
      </ul>
    </nav>

    <h1 class="title">{{ thirdparty?.name }}</h1>

    <div class="box">
      <table class="table is-fullwidth">
        <tbody>
          <tr>
            <th>Email</th>
            <td>{{ thirdparty?.email }}</td>
          </tr>
          <tr>
            <th>Org Number</th>
            <td>{{ thirdparty?.org_number || '-' }}</td>
          </tr>
          <tr>
            <th>Address</th>
            <td>
              {{ thirdparty?.address1 }}
              <br />
              {{ thirdparty?.address2 }}
            </td>
          </tr>
          <tr>
            <th>City / Zip</th>
            <td>{{ thirdparty?.zipcode }} {{ thirdparty?.place }}</td>
          </tr>
          <tr>
            <th>Region</th>
            <td>{{ thirdparty?.region || '-' }}</td>
          </tr>
          <tr>
            <th>Country</th>
            <td>
              {{ thirdparty?.country || '-' }} ({{ thirdparty?.country_code }})
            </td>
          </tr>
          <tr>
            <th>Contact Person</th>
            <td>{{ thirdparty?.contact_person || '-' }}</td>
          </tr>
          <tr>
            <th>Contact Ref</th>
            <td>{{ thirdparty?.contact_reference || '-' }}</td>
          </tr>
          <tr>
            <th>Peppol</th>
            <td>
              {{ thirdparty?.peppol_endpoint_id || '-' }} <br />
              Scheme: {{ thirdparty?.peppol_scheme_id || '-' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="buttons">
      <router-link
        :to="{ name: 'EditThirdParty', params: { id: thirdparty?.id } }"
        class="button is-info"
      >
        Edit
      </router-link>
      <router-link
        :to="{ name: 'DashboardThirdParties' }"
        class="button is-light"
      >
        Back
      </router-link>
    </div>
  </div>
</template>

<script>
import api from '@/utils/axios';

export default {
  name: 'ThirdPartyView',
  data() {
    return {
      thirdparty: null,
    };
  },
  mounted() {
    this.getThirdParty();
  },
  methods: {
    getThirdParty() {
      const id = this.$route.params.id;
      api
        .get(`/third-parties/${id}/`)
        .then((response) => {
          this.thirdparty = response.data;
        })
        .catch((error) => {
          console.error('Error loading third party:', error);
        });
    },
  },
};
</script>
